<template>
  <kst-page-new
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details :userData="userData"/>
    <Items
      :userData="userData"
      :userItems="userItems" 
      :specialPriceOptions="specialPriceOptions"
      :warehouseOptions="warehouseOptions"
    />

    <div class="columns">
      <div class="column">
        <Details2 :userData="userData"/>
      </div>
      <div class="column">
        <Total :userData="userData"/>
      </div>
    </div>
  </kst-page-new>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../StclModel.js";
import StclItemCatalog from "../StclItemCatalog.js";
import Services from "../../../services/Api/StockClosingServices.js";

import Details from "./StclN_Details.vue";
import Details2 from "./StclN_Details2.vue";
import Items from "./StclN_Items.vue";
import Total from "./StclN_Total.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    Details,
    Details2,
    Items,
    Total
  },
  data: () => ({
    userData: {},
    userItems: [],
    specialPriceOptions: {},
    warehouseOptions: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(loadNew) {
      this.resetData();

      const config = Services.getNewData();
      loadNew(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.specialPriceOptions = Model.getSpecialPriceOptions(
        data.SpecialPriceList, null, StclItemCatalog.SpecialPriceID.Label
      );
      this.warehouseOptions = Model.getWarehouseOptions(data.WarehouseList);

      Model.setDetailsBySpecialPrice(this.userData,
        this.specialPriceOptions.rows.length);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData, this.userItems);
      const config = Services.postData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.userItems = [];
      this.specialPriceOptions = {};
      this.warehouseOptions = {};
    }
  }
}
</script>